import { render, staticRenderFns } from "./QuestionAddress.vue?vue&type=template&id=1dbf774a&scoped=true&"
import script from "./QuestionAddress.vue?vue&type=script&lang=js&"
export * from "./QuestionAddress.vue?vue&type=script&lang=js&"
import style0 from "./QuestionAddress.vue?vue&type=style&index=0&id=1dbf774a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbf774a",
  null
  
)

export default component.exports